module.exports = __webpack_public_path__ + "static/media/website.d453e1bb.svg";